import type {
  CreateTeamInput,
  FindTeamMembersResponse,
  Nurse,
  Team,
  TeamMemberDetail,
  UpdateTeamInput,
  UserIdentity,
} from "dutyon-server/types";
import { httpClient } from "./httpClient";

export const findMyTeamMembers = async ({
  page,
  limit,
  teamId,
}: {
  page: number;
  limit: number;
  teamId?: string;
}): Promise<FindTeamMembersResponse> => {
  const response = await httpClient.get<FindTeamMembersResponse>("/teams/my/members", {
    params: { page, limit, teamId },
  });
  return response.data;
};

export const findMyTeamMember = async (id: string): Promise<TeamMemberDetail> => {
  const response = await httpClient.get<TeamMemberDetail>(`/teams/my/members/${id}`);
  return response.data;
};

export interface TeamAttendanceStatus {
  id: string;
  nurseId: string;
  name: string;
  position: string | null;
  profileImage: string | null;
  status: "WORKING" | "OFFLINE" | "COMPLETED" | "BEFORE_WORK";
  startTime: Date | null;
  endTime: Date | null;
}

export const getMyTeamAttendances = async (): Promise<TeamAttendanceStatus[]> => {
  const response = await httpClient.get<TeamAttendanceStatus[]>("/teams/my/attendances");
  return response.data;
};

export type TeamWithCounts = Team & {
  _count: { nurses: number };
  nurses: (Nurse & { user: UserIdentity })[];
};

export interface FindAllTeamsResponse {
  list: TeamWithCounts[];
  total: number;
}

export const findAllTeams = async ({
  page = 1,
  limit = 10,
}: {
  page?: number;
  limit?: number;
} = {}): Promise<FindAllTeamsResponse> => {
  const response = await httpClient.get<FindAllTeamsResponse>("/teams", {
    params: { page, limit },
  });
  return response.data;
};

export const findOneTeam = async (id: string): Promise<Team | null> => {
  const response = await httpClient.get<Team | null>(`/teams/${id}`);
  return response.data;
};

export type CreateTeamDto = CreateTeamInput;

export const createTeam = async (data: CreateTeamDto): Promise<Team> => {
  const response = await httpClient.post<Team>("/teams", data);
  return response.data;
};

export type UpdateTeamDto = UpdateTeamInput;

export const updateTeam = async ({
  id,
  data,
}: {
  id: string;
  data: UpdateTeamDto;
}): Promise<Team> => {
  const response = await httpClient.put<Team>(`/teams/${id}`, data);
  return response.data;
};

export const removeTeam = async (id: string): Promise<Team> => {
  const response = await httpClient.delete<Team>(`/teams/${id}`);
  return response.data;
};
